import React, { useState, useRef, useEffect } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TotalShiftIcon from '../../../../../assets/OrgDashboard/total-shift-requests-icon.svg';
import {
  StyledShiftRequestsCard,
  ShiftRequestsHeader,
  TotalShiftsInfo,
  TextBlock,
  TotalShiftsValue,
  DropdownWrapper,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  StatusList,
  StatusItem,
  StatusLabel,
  StatusDot,
  StatusCount,
  ViewAllWrapper,
  ViewAllBtn
} from './style';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../../../store';
import { fetchOrgShiftRequests, selectOrgDashboardData } from '../../../../../modules/orgDashboard';
import { useNavigate } from 'react-router-dom';

const ShiftRequestsCard: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const dashboardData = useSelector(selectOrgDashboardData);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState('This Week');
  const dropdownRef = useRef<HTMLDivElement>(null);

  const periods = ['Today', 'This Week', 'This Month', 'This Year'];

  const shiftData = dashboardData.shiftRequests;

  const statuses = [
    { label: 'Completed Shift', count: shiftData?.completed || 0, color: '#62B089' },
    { label: 'Pending Shift', count: shiftData?.pending || 0, color: '#EDC05D' },
    { label: 'Rejected Shift', count: shiftData?.rejected || 0, color: '#D94D4D' },
    { label: 'Cancelled Shift', count: shiftData?.cancelled || 0, color: '#9CA3AF' }
  ];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <StyledShiftRequestsCard>
      <ShiftRequestsHeader>
        <TotalShiftsInfo>
          <div className="icon-container">
            <img src={TotalShiftIcon} alt="Total Shifts" />
          </div>
          <TextBlock>
            <span>Total Shift Requests</span>
            <TotalShiftsValue>{shiftData?.total || 0}</TotalShiftsValue>
          </TextBlock>
        </TotalShiftsInfo>

        <DropdownWrapper ref={dropdownRef}>
          <DropdownTrigger onClick={() => setIsOpen(!isOpen)}>
            <div className="trigger-content">
              <CalendarMonthIcon style={{ fontSize: '16px', color: '#666' }} />
              {selectedPeriod}
            </div>
            <KeyboardArrowDownIcon />
          </DropdownTrigger>
          {isOpen && (
            <DropdownMenu>
              {periods.map(period => (
                <DropdownItem 
                  key={period} 
                  selected={selectedPeriod === period}
                  onClick={() => {
                    setSelectedPeriod(period);
                    dispatch(fetchOrgShiftRequests(period));
                    setIsOpen(false);
                  }}
                >
                  {period}
                </DropdownItem>
              ))}
            </DropdownMenu>
          )}
        </DropdownWrapper>
      </ShiftRequestsHeader>

      <StatusList>
        {statuses.map((status, index) => (
          <StatusItem key={index}>
            <StatusLabel>
              <StatusDot color={status.color} />
              {status.label}
            </StatusLabel>
            <StatusCount>{status.count}</StatusCount>
          </StatusItem>
        ))}
      </StatusList>

      <ViewAllWrapper>
        <ViewAllBtn onClick={() => navigate('/shifts-board')}>View All</ViewAllBtn>
      </ViewAllWrapper>
    </StyledShiftRequestsCard>
  );
};

export default ShiftRequestsCard;
